import React, { useEffect } from "react";
import styles from "./index.module.scss";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  addToCart,
  incrementBasketAmount,
  setCart,
} from "../../../../../redux/reducers";
import { getCartState } from "../../../../../redux/selectors";
import { isInBusket } from "../../../../../utils/functions/isInBasket";
import { toast } from "react-toastify";
import { SplitToLines } from "../../../../../utils/functions/nextLineString";
interface cardProps {
  img: string;
  title: string;
  descrip: string;
  price: number;
  days: number;
  i: number;
}
const Card = ({ descrip, img, price, title, days, i }: cardProps) => {
  const dispatch = useAppDispatch();
  const cart = useAppSelector((state) => getCartState(state));

  const addCartHandler = (id: number, name: string) => {
    let inCart = isInBusket(cart, name, id);
    console.log(inCart);

    if (inCart) {
      dispatch(incrementBasketAmount(id));
      toast("Увеличено в корзине", {
        position: "top-right",
        type: "success",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    } else {
      dispatch(
        addToCart({
          id,
          detailName: name,
          price,
          amount: 1,
          catalogType: descrip,
        })
      );
      console.log(cart);

      toast("Добавлено в корзину", {
        position: "top-right",
        type: "success",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };
  return (
    <div className={styles.card} key={i}>
      <img src={img} alt="" />
      <div className={styles.info}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.descrip}>{SplitToLines(descrip)}</p>
      </div>
      <button
        className={styles.button}
        onClick={() => {
          addCartHandler(i, title);
        }}
      >
        <span className={styles.price}>
          {price} &#8381;
          <span> {days} шт</span>
        </span>
        <span>
          <i className="fa-solid fa-cart-shopping" />
        </span>
      </button>
    </div>
  );
};

export default Card;
